/* !
 * jQuery contact v1.0.0
 * Copyright 2020, Connecty Inc.
 */
(function($, SLSD){

	// ＜器材に関するお問い合わせ＞サンプルをご希望される製品 ブロックの開閉
	const setSampleSelect = () => {
		const checkSampleWish = () => {
			if ($('#sample_wish').prop('checked')) {
				$('.js-sampleSelect-input').show();
				$('.js-sampleSelect-address').show();
				$('.js-sampleSelect-tel').show();
			} else {
				$('.js-sampleSelect-input').hide();
				$('.js-sampleSelect-address').hide();
				$('.js-sampleSelect-tel').hide();
				$('.js-sampleSelect-address input').val('');
				$('.js-sampleSelect-address textarea').val('');
				$('.js-sampleSelect-tel input').val('');
				$('.js-sampleSelect-input').find('input[type="checkbox"]').each((idx, val) => {
					$(val).prop('checked', false);
				});
			}
		}
		$('.js-sampleSelect-input').hide();
		$('.js-sampleSelect-address').hide();
		checkSampleWish();

		$('input[name="sample_wish"]').on('change', () => {
			checkSampleWish();
		})
	};
	// ＜器材に関するお問い合わせ＞希望する場合は1つ以上チェック必須
	const errCheckSampleSelect = () => {
		$('.js-submit').on('click', () => {
			if ($('#sample_wish').prop('checked')) {
				let flg = false;
				$('input[name="sample"]').each((idx, val) => {
					if ($(val).prop('checked')) {
						flg = true;
					}
				});
				if (!flg) {
					$('.js-sampleSelect-errMsg').removeClass('di_none');
				} else {
					$('#contact_product').submit();
				}
			}
		});
	};
	// <フォーラム演題登録>演者枠を追加（最大10名まで）
	const addPerformer = () => {
		const a = 'is-active';
		const performerList = $('.js-performerList');
		const addPerformerBtn = $('.js-addPerformer');

		// ＜確認画面:エラー＞記入のあるn番目まで表示(間に未記入の枠がある場合も問答無用で0～n番目まで表示する）
		$('.js-performerList-item .mod-input').each((idx, ele) => {
			if($(ele).val() !== '') {
				$(ele).parents('.js-performerList-item').addClass(a);
				$(`.js-performerList-item:lt(${$(ele).parents('.js-performerList-item').index()})`).addClass(a);
			}
		});

		// ＜入力画面＆確認画面:エラー＞現在表示されている演者枠の数
		let performerListLen = $('.js-performerList-item').filter(':visible').length;

		// ＜入力画面＆確認画面:エラー＞演者6以降をボタンクリックで表示
		addPerformerBtn.on('click', () => {
			$('.js-performerList-item').eq(performerListLen).addClass(a);
			performerListLen += 1;
			if(performerListLen >= 10) {
				addPerformerBtn.remove();
			}
		});
	};

	// ＜共通＞フォームクリア
	const clearInput = () => {
		$('.js-clear').on('click', () => {
			$('form').get(0).reset();
			if (SLSD.va.pathname === '/contact/product/' || SLSD.va.pathname === '/contact/product/index.html') {
				setSampleSelect();
			}
		});
	}

	if (SLSD.va.pathname === '/contact/product/' || SLSD.va.pathname === '/contact/product/index.html'
		|| SLSD.va.pathname === '/en/contact/product/' || SLSD.va.pathname === '/en/contact/product/index.html') {
		setSampleSelect();
		errCheckSampleSelect();
	} else if (SLSD.va.pathname === '/contact/product/confirm.html'|| SLSD.va.pathname === '/contact/product/confirm_1.html'
		|| SLSD.va.pathname === '/contact/product/confirm_2.html' || SLSD.va.pathname === '/contact/product/confirm_3.html'
		|| SLSD.va.pathname === '/contact/product/confirm_4.html' || SLSD.va.pathname === '/en/contact/product/confirm.html'
		|| SLSD.va.pathname === '/en/contact/product/confirm_1.html' || SLSD.va.pathname === '/en/contact/product/confirm_2.html'
		|| SLSD.va.pathname === '/en/contact/product/confirm_3.html' || SLSD.va.pathname === '/en/contact/product/confirm_4.html') {
		setSampleSelect();
		errCheckSampleSelect();
		if (!$($('.js-sampleSelect-confirm').find('pre').text() !== '').length) {
			$('.js-sampleSelect-confirm').hide();
			$('.js-sampleSelect-address-confirm').hide();
			$('.js-sampleSelect-tel-confirm').hide();
		}
		$('.js-sampleSelect-confirm_list').each((idx, ele) => {
			if (!$($(ele).find('pre').text() !== '').length) {
				$(ele).prev('.js-sampleSelect-confirm_title').remove();
			}
		});

	} else if(SLSD.va.pathname === '/contact/forum_title/' || SLSD.va.pathname === '/contact/forum_title/index.html') {
		addPerformer();
	} else if(SLSD.va.pathname === '/contact/forum_title/confirm.html') {
		addPerformer();
		$('.js-performerList-item-confirm').each((idx, ele) => {
			if ($(ele).find('.js-performerList-item-confirm_name').text() === '') {
				$(ele).hide();
			}
		});
	}

	clearInput();

})(window.jQuery, window.SLSD);
